import api, { ApiResponse } from "./index";

interface courseListParams {
    id:number|string,
}
interface GetRoomParams {
    account:string
}
export interface CourseInfo {
    
}

interface CourseRequest<T = ApiResponse> {
    getCourseDetail(params:courseListParams):Promise<ApiResponse<any>>,
    getCourseList():Promise<ApiResponse<any>>,
    getRoom(params:GetRoomParams):Promise<ApiResponse<any>>,
}

const courseApi: CourseRequest = {
    getCourseList() {
        return api.post('/api/sskt/course_list.do')
    },
    getCourseDetail(params) {
        return api.post('/api/sskt/detail.do',params)
    },
    getRoom(params) {
        return api.post('/api/sskt/get_rooms.do',params)
    }
}

export default courseApi